import { BasisHeaderLock, BasisHeaderUnLock } from '../basisHeader';

export const basisFooter = () => {
  const component: HTMLElement = document.querySelector('[is="basis-footer"]');

  /**
   * Make sure the year is up to date regardless of the cached version of the page
   */
  const handleYear = () => {
    const el: HTMLSpanElement = component.querySelector('.year');
    if (!el) return;
    el.innerText = new Date().getFullYear().toString();
  };

  const handleBackToTop = () => {
    const links = Array.from(
      component.querySelectorAll('.backToTop-link')
    ) as HTMLAnchorElement[];
    const backToTopEl = component.querySelector('.backToTop');

    if (backToTopEl) {
      const threshold = window.innerHeight * 0.5;
      const toggle = () => {
        backToTopEl.classList.toggle(
          'backToTop--visible',
          window.scrollY > threshold
        );
      };
      toggle();
      window.addEventListener('scroll', toggle, { passive: true });
    }

    links.forEach((link) => {
      link.addEventListener('click', (e: MouseEvent) => {
        const targetId = link.getAttribute('href').replace('#', '');
        const targetElement = document.getElementById(targetId);
        if (!targetElement) return;

        BasisHeaderLock();
        e.preventDefault();
        targetElement.tabIndex = -1;
        targetElement.focus();
        BasisHeaderUnLock();
      });
    });
  };

  handleYear();
  handleBackToTop();
};
